import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ShopCollections.css";
import PlantLogo from "../assets/plants.jpeg";

const API_BASE_URL = process.env.REACT_APP_BASE_URL;

function ShopCollections() {
  const [subcategories, setSubcategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchSubcategories() {
      try {
        const response = await fetch(`${API_BASE_URL}/product/subcategories/`);
        if (response.ok) {
          const data = await response.json();
          setSubcategories(data);
        } else {
          console.error("Failed to fetch subcategories");
        }
      } catch (error) {
        console.error("Error fetching subcategories:", error);
      }
    }

    fetchSubcategories();
  }, []);

  const handleCategoryClick = (subcategory) => {
    navigate(`/products/${subcategory.category.name.toLowerCase()}`, {
      state: { subCategory: subcategory.name },
    });
  };

  return (
    <section className="shop-collections-section pt-0 py-4">
      <h3 className="text-center mb-4">Shop Our Collections</h3>
      <div className="collections-container">
        <div className="collections-wrapper">
          {subcategories.length > 0 ? (
            subcategories.map((subcategory, index) => (
              <div
                key={index}
                className="collection-item"
                onClick={() => handleCategoryClick(subcategory)}
              >
                <div className="collection-box">
                  <img
                    src={subcategory.image ? subcategory.image : PlantLogo}
                    alt={subcategory.name}
                    className="collection-image"
                  />
                  <p className="collection-title">{subcategory.name}</p>
                </div>
              </div>
            ))
          ) : (
            <p className="loading-text">Loading collections...</p>
          )}
        </div>
      </div>
    </section>
  );
}

export default ShopCollections;
